import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import store from '@store';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Menu } from 'primereact/menu';

import Header from '@components/Header';
import NewLanguageModal from '@components/Languages/NewLanguageModal';
import EditLanguageModal from '@components/Languages/EditLanguageModal';
import JustificationModal from '@components/JustificationModal';
import AddTextModal from '@components/Traslate/AddTextModal';

import { getAllLanguagesList, newLanguage, editLanguage, updateVisibilityStatus, deleteLanguage, reOrderLanguage, addTextDictionary } from '@actions/locale';
import { setCatalogLanguageTabs, setCatalogLanguageItems, setCatalogLanguageKeys } from '@actions/catalogs'
import { validatePermissionAction } from '@actions/sessionPermission';
import { sendActionToBitacora  } from '@actions/bitacora';

import { getValueLanguageObj } from '@utils/general'

import {
  StatusVisible,
  NOT_ERASABLE,
  LANGUAGE_DEFAULT
} from '@constants/general'
import catalogPermissionsId from '@constants/catalogPermissionsId';
import { SET_CATALOG } from '@constants/actionType'


import './style.scss'

const IS_UPDATE_GLOBAL_STATE = true
class Language extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loadingTable: true,
      languages: [],
      findText: '',
      typeCountry: '',
      showModalLanguage: {
        isVisible: false,
        continueAction: null,
      },
      showModalEditLanguage: {
        isVisible: false,
        data: {},
        continueAction: null,
      },
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
      showModalAddText: {
        isVisible: false
      },
      lazyParams: {
        first: 0,
        rows: 10,
        page: 0,
      }
    };

    this.items = [
      {
        label: this.props.t('Nuevos textos al Diccionario General'),
        icon: 'pi pi-cog',
        command: () => {
          this.openModalAddNewText()
        }
    },
    ]
  }

  async componentDidMount() {
    await this.loadData();
    return this.setState({loadingPage: false})
  }

  loadData = async (isUpdate = false) => {
    const { getAllLanguagesList } = this.props;
    this.setState({ loadingTable: true });
    const params = {
      type: 'all'
    };
    const response = await getAllLanguagesList(params);
    if (!response?.status) {
      if (isUpdate) this.setCatalogsLanguageUpdate(response.data)
      return this.setState({
        languages: response.data,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };

  setCatalogsLanguageUpdate = async (data) => {
    const { setCatalogLanguageTabs, setCatalogLanguageItems, setCatalogLanguageKeys } = this.props
    // const getVisiblesLanguage = data.filter(item => item.visible === 1)  TODO Se comenta temporalmente hasta salir con micrositio en multiidioma
    const getVisiblesLanguage = data

    await store.dispatch({
      type: SET_CATALOG,
      payload: {nameCatalog: 'languagesCatalog', data: getVisiblesLanguage}
    })
    await setCatalogLanguageTabs()
    await setCatalogLanguageItems()
    await setCatalogLanguageKeys()
  }

  onConfirmDeleteDocument = (data) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea eliminar {{ELEMENTO}}?', {ELEMENTO: getValueLanguageObj(data.fc_nombre)}),
        label: t('Justificación de la eliminación'),
        continueAction: ({justification}) => this.onDeleteLanguage(data, justification),
      },
    });
  }

  onDeleteLanguage = async (data, justification) => {
    const { t, deleteLanguage, sendActionToBitacora } = this.props;
    this.setState({loadingTable: true})
    const response = await deleteLanguage({clave: data.clave, justification});
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'bajaIdioma',
        reason: `${getValueLanguageObj(data.nombre, LANGUAGE_DEFAULT)} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData(IS_UPDATE_GLOBAL_STATE);
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    this.setState({loadingTable: false})
  };


  templateDelete = (node, detail) => {
    if (node.borrable === NOT_ERASABLE) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
        </>
      )
    }
    return (
    <div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-trash"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.onConfirmDeleteDocument(node)}
      />
    </div>)
  };


  onOpenodalEditLanguage = (node) => {
    this.setState({
      showModalEditLanguage: {
        isVisible: true,
        data: node,
        continueAction: (data) => this.onEditCountry(data),
      },
    });
  }

  onEditCountry = async (data) => {
    const { t, editLanguage, sendActionToBitacora } = this.props
    this.setState({loadingTable: true})
    const response = await editLanguage(data)
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'actIdioma',
        reason: `${getValueLanguageObj(data.name, LANGUAGE_DEFAULT)} || ${data.justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData(IS_UPDATE_GLOBAL_STATE);
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    this.setState({loadingTable: false})
  }

  templateEdit = (node, detail) => (
    <div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.onOpenodalEditLanguage(node)}
      />
    </div>
  );

  columnDictionary = (node, detail) => {
    const { history } = this.props
    return (
      <div>
        <span className="p-column-title">{detail.header}</span>
        <Button
          type="button"
          icon="pi pi-book"
          className="p-button-text"
          style={{ marginRight: '.5em' }}
          onClick={() => history.push({pathname:'/languages/dictionary', state: {data: node}})}
        />
      </div>
    )
  };

  validateCountry = (node) => {
    const { countriesCurrentCatalog } = this.props
    const getCountry = countriesCurrentCatalog.find(item => item.id === node.fc_id_pais)
    return getCountry.label
  }

  visibleTemplate = (node, detail) => {
    const { t, validatePermissionAction } = this.props;
    const hasPermissionShowHiddenLenguage = validatePermissionAction(catalogPermissionsId.MOSTRAR_OCULTAR_IDIOMAS)
    if (node.visible === StatusVisible.IS_VISIBLE) {
      return (
        <div>
          <span className="p-column-title">{detail.header}</span>
          <Button
            type="button"
            icon="pi pi-check"
            className={`p-button-text ${hasPermissionShowHiddenLenguage ? '' : 'cursor-not-pointer'}`}
            style={{ marginRight: '.5em' }}
            onClick={hasPermissionShowHiddenLenguage ? () => this.onConfirmVisible(node) : () => {}}
          />
        </div>
      );
    }
    if (node.visible === StatusVisible.IS_HIDDEN) {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className={`badge-red cursor-pointer ${hasPermissionShowHiddenLenguage ? '' : 'cursor-not-pointer'}`} aria-hidden="true" onClick={hasPermissionShowHiddenLenguage ? () => this.onConfirmVisible(node) : () => {}}> {t('OCULTO')} </span>
        </>
      );
    }
    return (<span className="p-column-title">{detail.header}</span>);
  }

  onHideModal = () => {
    this.setState({
      showModalLanguage: {
        isVisible: false,
      },
    });
  };

  openMoldalNewCountry = () => {
    this.setState({
      showModalLanguage: {
        isVisible: true,
        continueAction: (data, justification) => this.createNewLanguage(data, justification),
      },
    });
  }

  createNewLanguage = async (data, justification) => {
    const { t, newLanguage, sendActionToBitacora } = this.props
    this.setState({loadingTable: true})

    const response = await newLanguage(data)
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'altaIdioma',
        reason: `${getValueLanguageObj(data.name, LANGUAGE_DEFAULT)} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      
      await this.loadData(IS_UPDATE_GLOBAL_STATE);
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    this.setState({loadingTable: false})
  }

  onConfirmVisible = (data) => {
    const { t } = this.props;
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        continueAction: ({justification}) => this.onChangeVisibleStatus(data, justification),
      },
    });
  };

  onChangeVisibleStatus = async (data, justification) => {
    const { t, updateVisibilityStatus, sendActionToBitacora } = this.props;
    this.setState({loadingTable: true})
    const response = await updateVisibilityStatus({...data, justification});
    if (!response?.status) {
      const dataBitacora = {
        transactionName: data.visible === StatusVisible.IS_VISIBLE ?  'desacIdioma' : 'activaIdioma',
        reason: `${getValueLanguageObj(data.nombre, LANGUAGE_DEFAULT)} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      await this.loadData(IS_UPDATE_GLOBAL_STATE);
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
    }
    this.setState({loadingTable: false})
  };

  onHideModal = () => {
    this.setState({
      showModalJustification: {
        isVisible: false,
      },
    });
  };

  openModalAddNewText = () => {
    return this.setState({
      showModalAddText: {
        isVisible: true
      }
    })
  }

  onAddNewTex = async ({justification, newTexts}) => {
    const { addTextDictionary, sendActionToBitacora} = this.props
    const formatText = newTexts.reduce((obj, item) => {
      obj[item] = item
      return obj
    }, {})

    const response = await addTextDictionary(formatText)
    if (!response?.status) {
      const dataBitacora = {
        transactionName: 'altaTextosIdioma',
        reason: `${newTexts} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
    }

  }

  columnLanguage = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {getValueLanguageObj(rowData.nombre)}
    </>
  )

  onRowReorder = async (newOrden) => {
    const { reOrderLanguage } = this.props
    this.setState({loadingTable: true})
    const formatData = newOrden.value.map((item, index) => ({ clave: item.clave, orden: index + 1}))
    const response = await reOrderLanguage(formatData)
    if (!response.status) {
      this.setState({languages: newOrden.value})
    }
    this.setState({loadingTable: false})
  }

  render() {
    const { t, history, validatePermissionAction, isFullAdmin  } = this.props;
    const { loadingPage, languages, loadingTable, showModalLanguage, showModalEditLanguage, showModalJustification, showModalAddText } = this.state;
    if (loadingPage) return true

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        { validatePermissionAction(catalogPermissionsId.AGREGAR_IDIOMAS) && (
          <Button
            label={t('Agregar Idiioma')}
            className="p-button-primary"
            onClick={() => this.openMoldalNewCountry() }
          />
        )}
      </>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Idiomas')} rightComponent={rightHeader} />
          <div className="card">
          { isFullAdmin && (
            <div className='p-col-12 p-d-flex p-jc-end'>
              <Menu model={this.items} popup ref={el => this.menu = el} id="popup_menu" />
              <Button
                // label="Show"
                className='p-button-secondary p-button-outlined'
                icon="pi pi-ellipsis-v"
                onClick={(event) => this.menu.toggle(event)}
                aria-controls="popup_menu"
                aria-haspopup
              />
            </div>
          )}
            <div className="p-col-12 p-mt-2">
              <DataTable
                value={languages}
                lazy
                loading={loadingTable}
                className="table-languages"
                onRowReorder={this.onRowReorder}
              >
                <Column
                  rowReorder
                  style={{width: '4em'}}
                  header={t('Orden')}
                  className="sm-invisible"
                />
                <Column
                  header={t('Nombre')}
                  body={this.columnLanguage}
                />
                <Column
                  header={t('Diccionario')}
                  body={this.columnDictionary}
                  className="column-max p-text-center-lg"
                />
                { validatePermissionAction(catalogPermissionsId.EDITAR_IDIOMAS) && (
                  <Column
                    header={t('Editar')}
                    body={this.templateEdit}
                    className="column-action p-text-center-lg"
                  />
                )}
                <Column
                  header={t('Visible')}
                  body={this.visibleTemplate}
                  className="column-max p-text-center-lg"
                />
                { validatePermissionAction(catalogPermissionsId.ELIMINAR_IDIOMAS) && (
                  <Column
                    header={t('Eliminar')}
                    body={this.templateDelete}
                    className="column-action p-text-center-lg"
                  />
                )}
              </DataTable>
            </div>
          </div>
        </div>
        <Toast ref={(el) => (this.toast = el)} />
        { showModalLanguage.isVisible && (
          <NewLanguageModal
            onHidden={() => this.setState({showModalLanguage: {isVisible: false}})}
            onContinueAction={showModalLanguage.continueAction}
            languagesList={languages}
          />
        )}
        { showModalEditLanguage.isVisible && (
          <EditLanguageModal
            onHidden={() => this.setState({showModalEditLanguage: {isVisible: false}})}
            data={showModalEditLanguage.data}
            onContinueAction={showModalEditLanguage.continueAction}
            languagesList={languages}
          />
        )}
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.onHideModal()}
          onContinueAction={showModalJustification.continueAction}
        />
        { showModalAddText.isVisible && (
          <AddTextModal
            display={showModalAddText.isVisible}
            onHidden={() => this.setState({showModalAddText: {visible: false}})}
            onContinueAction={this.onAddNewTex}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesCurrentCatalog: state.catalogs.countriesCurrentCatalog,
  isFullAdmin: state.settings.isFullAdmin,
});

const mapDispatchToProps = {
  getAllLanguagesList,
  newLanguage,
  editLanguage,
  updateVisibilityStatus,
  reOrderLanguage,
  deleteLanguage,
  setCatalogLanguageTabs,
  setCatalogLanguageItems,
  setCatalogLanguageKeys,
  validatePermissionAction,
  sendActionToBitacora,
  addTextDictionary
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Language);
